<template>
    <div class="c-schedule-list js-schedule-list" ref="js-schedule-list"
        @scroll.passive="scrollRelative()"
        :data-component-name="$options.name"
    >
        <FloatingDateRangePicker
            @set-current-date="$emit('set-current-date', $event)"
            :currentDate="currentDate"
        />

        <!-- <div>{{loading}}</div> -->
        <div class="c-schedule-list-week__wrap"
            :key="w"
            v-for="(week, w) in weeks"
            :class="{'-is-disabled': week.itemsCount==0}"
        >
            <div class="c-schedule-list-week">
                {{ week.label }}
                <div
                    class="-buttons"
                >
                    <div class="" :title="week.assignmentsCount+' affectation(s)'"
                        :class="{'-text-red': week.assignmentsCount==0,
                                '-text-blue': week.assignmentsCount>0
                        }"
                    >
                        <q-icon name="assignment_ind" /> {{ week.assignmentsCount }}
                    </div>
                    <div class="q-ml-sm -text-orange" :title="week.absencesCount+' absence(s)'" v-if="week.absencesCount>0">
                        <q-icon name="flight" /> {{ week.absencesCount }}
                    </div>
                    <div class="q-ml-sm -text-red" :title="week.canceledCount+' annulation(s)'" v-if="week.canceledCount>0">
                        <q-icon name="assignment_late" /> {{ week.canceledCount }}
                    </div>
                    <!-- <div class="-picker-cell">
                        <RangePicker
                            v-model="week.weekrange.str"
                            @set-current-date="$emit('set-current-date', $event)"
                        />                        
                    </div> -->
                </div>
            </div>
            <div class="c-schedule-list-day__wrap"
                :key="d"
                :id="'day-'+day.dateStr"
                v-for="(day, d) in week.days"
                :class="{'-is-disabled': day.data.length==0}"
            >
                <div class="c-schedule-list-day">
                    {{ day.label }}
                    <span
                        v-if="day.data.length==0"
                    >
                        Aucune affectation pour cette journée.
                    </span>
                </div>
                <div class="c-schedule-list-assignment__row"
                    :key="a"
                    v-for="(assignment, a) in day.data"
                    :class="assignment.state"
                >
                    <div class="-absence" v-if="assignment.__typename=='ResourceUnavailability'">
                        <!-- {{ assignment }} -->
                        <div class="-absence-name">
                            <q-icon :style="'color:'+ assignment.type.color" name="label"></q-icon> {{ assignment.type.name }}
                        </div>
                    </div>
                    <div class="-project" v-if="assignment.__typename=='ResourceAssignment'">
                        <div class="-project-name">
                            {{ assignment.project.name }}
                            <ProjectCardToggle class="q-ml-sm" :projectID="assignment.project.id" :myAssignments="true" :projectShiftID="assignment.projectShift.id" :size="'16px'" />

                        </div>
                        <div class="-project-profession">
                            {{ assignment.projectShift.name }}
                        </div>
                    </div>
                    <div class="-times" v-if="assignment.__typename=='ResourceAssignment'">
                        <div>
                            {{ assignment.start_time.split(':')[0]+"h"+ assignment.start_time.split(':')[1]}}
                        </div>
                        <div>
                            {{ assignment.end_time.split(':')[0]+"h"+ assignment.end_time.split(':')[1]}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-schedule-list-week__wrap -load-more" v-if="Object.keys(weeks).length>maxWeeks">
            <button class="o-button" @click.prevent="loadNextWeeks">
                Charger les semaines suivantes
            </button>
        </div>
        <div class="c-schedule-list-week__wrap -load-more" ref="js-loadNext" v-else-if="!loading">
            Chargement des semaines suivantes
        </div>
        <div class="c-schedule-list-week__wrap -load-more" v-else>
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
    </div>
</template>
<script>
    import { RESOURCESASSIGNMENTS } from "@/graphql/resource/queries";
	import { RESOURCEUNAVAILABILITIES } from "@/graphql/resourceUnavailability/queries"
    import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
    import { CONFIRMASSIGNMENTCANCEL } from "@/graphql/assignment/mutations"
	// import AcceptationSelect from "@/components/forms/AcceptationSelect"
    import {getWeeksLimits, getDatesBetween, monthStr, dayOfWeekStr /*, dayStr*/} from '@/js/dateUtilities'
    import moment from 'moment';
    import {hexColorFromString} from '@/js/utilities'
    import orderBy from "lodash/orderBy";
    import FloatingDateRangePicker from '@/components/nav/FloatingDateRangePicker'

    export default {
        name: 'ResourceScheduleList',
        components: { FloatingDateRangePicker },
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
			currentDate: {
                type: String,
                default: null
            },
			resourceID: {
				type: [Number, String],
				default: null,
			},
            relativePosition: {
                type: [Boolean],
                defailt: false
            },
            scheduleScrollTo: {
                type: String,
                default: null
            }
        },
        data(){
        	return {
                weeks: {},
                firstDate: null,
                lastDate: null,
                lastDenyReason: null,
				maybeButton: "Peut-être",
                confirmedCancellation: [],
                loading: true,
                maxWeeks: 52,
                rangeOffset: 49,
                emitLoadedTO: {},
                prevKeyDownListener: null,
                scheduleScrollToVar: this.scheduleScrollTo
        	}
        },
        mounted(){
            this.firstDate=this.weekrange.obj.from
            this.lastDate=this.weekrange.obj.to
            this.parseWeeks();

            if(document.onkeydown) this.prevKeyDownListener=document.onkeydown
            document.onkeydown = function(e){
                if (e.keyCode == 37 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.prevWeek)
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.nextWeek)
            }.bind(this)
            
            if(!this.relativePosition){
                document.addEventListener("scroll", this.onBodyScroll);
            }
        },
        beforeDestroy() {
            if(this.prevKeyDownListener) document.onkeydown = this.prevKeyDownListener
            if(!this.relativePosition){
                document.removeEventListener('scroll', this.onBodyScroll);
            }
        },
        computed: {
            prevWeek(){
                return moment(this.currentDate).subtract(7, 'days').format('YYYY-MM-DD');
            },
            nextWeek(){
                return moment(this.currentDate).add(7, 'days').format('YYYY-MM-DD');
            },
			weekrange(){
                let range=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek)
                let to=new Date(range.obj.to)
                to.setDate(to.getDate() + this.rangeOffset)
                return {
                    obj:{
                        from: range.obj.from,
                        to: to
                    },
                    str:{
                        from: range.str.from,
                        to: moment(to).format('YYYY-MM-DD')
                    }
                }
			},
        },
        watch: {
            currentDate(){
                this.weeks={};
                this.firstDate=this.weekrange.obj.from
                this.lastDate=this.weekrange.obj.to
                this.parseWeeks();
            },
            resourceID(){
                this.weeks={};
                this.firstDate=this.weekrange.obj.from
                this.lastDate=this.weekrange.obj.to
                this.parseWeeks();
            },
            confirmedCancellation(){
                Object.keys(this.weeks).forEach(function(weekIndex){
                    Object.keys(this.weeks[weekIndex].days).forEach(function(dayIndex){
                        this.weeks[weekIndex].days[dayIndex].data = this.weeks[weekIndex].days[dayIndex].data.filter(obj=>!this.confirmedCancellation.includes(obj.id));
                    }.bind(this))
                }.bind(this))
            },
            loading(){
                if(!this.loading) this.onBodyScroll();
            }
        },
        methods: {
            scrollRelative(){
                if(this.relativePosition) this.onBodyScroll();
            },
            hexColorFromString(string){
                return hexColorFromString(string)
            },
            loadNextWeeks(){
                this.weeks={};
                let date = new Date(this.lastDate)
                date.setDate(date.getDate() + 1)
                this.$emit('set-current-date', moment(date).format('YYYY-MM-DD'));
            },
            getMoreAssignments(range){
                this.$apollo.queries.resourceAssignments.fetchMore({ 
                    variables: {
                        resourceID: this.resourceID,
                        dateRange: range,
                        first: 250,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        this.parseData(fetchMoreResult.resourceAssignments.data)
                    }
                }).catch(function(){
                })
            },
            getMoreResourceUnavailabilitys(range){
                this.$apollo.queries.resourceUnavailabilities.fetchMore({ 
                    variables: {
                        resourceID: this.resourceID,
                        dateRange: range,
                        first: 250,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        this.parseData(fetchMoreResult.resourceUnavailabilities.data)
                    }
                }).catch(function(){
                })
            },
            getNextWeeks(){
                let date=new Date(this.lastDate)
                let prevDate=new Date(this.lastDate)
                this.lastDate=date.setDate(date.getDate() + this.rangeOffset)
                let range={
                    from: moment(prevDate).format('YYYY-MM-DD'),
                    to: moment(this.lastDate).format('YYYY-MM-DD'),
                }
                this.parseWeeks(function(){
                    this.getMoreAssignments(range);
                    this.getMoreResourceUnavailabilitys(range);
                }.bind(this));
            },
            onBodyScroll(){
                clearTimeout(this.emitLoadedTO);
                if(this.loading || Object.keys(this.weeks).length<1) return false;

                this.notificationScrollTo=setTimeout(function(){
                    let loadMoreEl = this.$refs["js-loadNext"];
                    let loadMoreParent = this.$refs["js-schedule-list"];
                    if (loadMoreEl && !this.loading) {
                        let marginTop = loadMoreEl.getBoundingClientRect().top+loadMoreEl.clientHeight-40;
                        let innerHeight = window.innerHeight;

                        if(this.relativePosition) {
                            innerHeight = loadMoreParent.getBoundingClientRect().height+loadMoreParent.getBoundingClientRect().top
                        }
                        if(marginTop<innerHeight){
                            this.loading=true;
                            this.getNextWeeks();
                        }
                    }
                }.bind(this), 300)
            },
			confirmAssignmentCancel(assignment=null){
				if(!assignment) return;
                this.confirmedCancellation.push(assignment.id)
                this.$apollo.mutate({
                    mutation: CONFIRMASSIGNMENTCANCEL,
                    variables: {
                        id: assignment.id,
                    }
				}).catch(function(){
                }).finally(function(){
					this.$eventBus.$emit('notifications-count', { projectID: assignment.project.id } )
                    this.onBodyScroll()
                    this.weeks=this.itemsCount(this.weeks)
                }.bind(this))
			},
			acceptAssignment(option, assignment=null){
				if(option.reason) this.lastDenyReason=option.reason;
				// this.noCacheUpdate=true;
				this.$apollo.mutate({
                    mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                    variables: {
                        assignmentID: assignment.id,
                        resourceID: this.resourceID,
                        action: option.value,
                        message: option.reason,
                        page: 1,
						first: 1,
						result: true
                    }
				}).then(function(data){                    
                    this.parseData(data.data.acceptAssignment.data)
					this.$eventBus.$emit('notifications-count', { projectID: assignment.project.id } )
					this.$eventBus.$emit('refresh-user-assignments', { resourceID: this.resourceID } )
                    this.onBodyScroll()
				}.bind(this)).catch(function(){
                })
				
			},
            parseData(datas){
                let weeks=JSON.parse(JSON.stringify(this.weeks))
                let items=JSON.parse(JSON.stringify(datas))

                items.forEach(function(data){

                    if(!this.confirmedCancellation.includes(data.id)){

                        let day=moment(data.date).format('YYYY-MM-DD');
                        let weekrange=getWeeksLimits(day, this.$generalSettings.settings.firstDayOfWeek);
                        let index=weekrange.str.from;

                        if(data.__typename=="ResourceUnavailability"){
                            data.start_time="00:00:00";
                            data.state='-absence'
                        }
                        if (data.__typename == "ResourceAssignment") {

                            // data.acceptation = {
                            //     label: 'En attente',
                            //     value: null,
                            //     icon: 'pending_actions',
                            //     currentClass: '-maybe'
                            // }
                            // data.state = '-published'
                        
                            // if (data.acceptedByUser){
                            //     data.state = '-completed'
                            //     data.acceptation = {
                            //         label: 'Acceptée',
                            //         value: 'accepted',
                            //         icon: 'verified',
                            //         currentClass: '-completed'
                            //     }
                            // }
                            // if(data.deniedByUser){
                            //     data.state='-alert'
                            //     data.acceptation={
                            //         label: 'Refusée',
                            //         value: 'denied',
                            //         icon: 'new_releases',
                            //         currentClass: '-denied'
                            //     }
                            // }
                            // if(data.maybeByUser){
                            //     data.state='-published'
                            //     data.acceptation={
                            //         label: 'Peut-être',
                            //         value: 'maybe',
                            //         icon: 'help',
                            //         currentClass: '-maybe'
                            //     }
                            // }
                            // if(data.notification_pending || data.notification_sent){
                            //     data.acceptation={
                            //         label: 'En attente',
                            //         value: null,
                            //         icon: 'pending_actions',
                            //         currentClass: '-maybe'
                            //     }

                            //     data.state='-published'
                            // }

                            if(data.hasAssignmentError) {
                                // data.acceptation=null;
                                data.state='-alert'
                            }

                            // if(data.canceled) {
                            //     // data.acceptation=null;
                            //     data.state='-canceled'
                            //     data.acceptation={
                            //         label: 'Ne plus afficher',
                            //         value: 'cancel',
                            //         icon: 'help',
                            //         // currentClass: '-canceled'
                            //     }
                            // }
                        }

                        if(weeks[index]){
                            weeks[index].days[day].data=weeks[index].days[day].data.filter(obj => obj.id!=data.id || data.__typename!=obj.__typename)
                            weeks[index].days[day].data.push(data);
                            weeks[index].days[day].data=orderBy(weeks[index].days[day].data, [item => item.start_time])
                        }
                    }
                    
                }.bind(this))

                weeks=this.itemsCount(weeks)

                this.weeks=weeks;

                if(this.scheduleScrollToVar){
                    let el=document.querySelector("#day-"+this.scheduleScrollToVar);
                    if(el){
                        this.$nextTick(function(){
                            this.$scrollTo( el, 100,
                                {
                                    x: false,
                                    y:true,
                                    container: ".js-schedule-list",
                                    onDone: function(){
                                        this.scheduleScrollToVar=null
                                    }.bind(this)
                                }
                            )
                        }.bind(this))
                    }
                }

            },
            itemsCount(weeks){
                Object.keys(weeks).forEach(function(weekindex){
                    weeks[weekindex].itemsCount=0;
                    weeks[weekindex].assignmentsCount=0;
                    weeks[weekindex].absencesCount=0;
                    weeks[weekindex].canceledCount=0;
                    Object.keys(weeks[weekindex].days).forEach(function(dayindex){
                        weeks[weekindex].itemsCount+=weeks[weekindex].days[dayindex].data.length
                        weeks[weekindex].days[dayindex].data.forEach(function(item){
                            if(item.__typename=="ResourceUnavailability") weeks[weekindex].absencesCount++;
                            if(item.__typename=="Assignment"){
                                if(!item.canceled && !this.confirmedCancellation.includes(item.id)) weeks[weekindex].assignmentsCount++;
                                if(item.canceled && !this.confirmedCancellation.includes(item.id)) weeks[weekindex].canceledCount++;
                            }
                        }.bind(this))
                    }.bind(this))
                }.bind(this))

                return weeks;
            },
            parseWeeks(callback){
                let dates=getDatesBetween(this.firstDate, this.lastDate)
                let weeks=JSON.parse(JSON.stringify(this.weeks));

                dates.forEach(function(date){
                    let day=(moment(date).format('YYYY-MM-DD'))
                    let weekrange=getWeeksLimits(new Date(date), this.$generalSettings.settings.firstDayOfWeek)
                    let index=weekrange.str.from
                    if(!weeks[index]){
                        weeks[index]={
                            days: {},
                            weekrange: weekrange,
                            label: '',
                            itemsCount: 0,
                            assignmentsCount: 0,
                            absencesCount: 0,
                            canceledCount: 0,
                            loading: true
                        }
                        if(weekrange.obj.from.getMonth()==weekrange.obj.to.getMonth()){
                            weeks[index].label="Semaine du " + weekrange.obj.from.getDate() + " au " + weekrange.obj.to.getDate() + " "+ monthStr(weekrange.obj.to).full.toLowerCase()+ " " + weekrange.obj.to.getFullYear()
                        }else{
                            if( weekrange.obj.from.getFullYear()==weekrange.obj.to.getFullYear() ){
                                weeks[index].label="Semaine du " + weekrange.obj.from.getDate() + " " + monthStr(weekrange.obj.from).full.toLowerCase()+ " au " + weekrange.obj.to.getDate() + " "+ monthStr(weekrange.obj.to).full.toLowerCase()+ " " + weekrange.obj.to.getFullYear()
                            }else{
                                weeks[index].label="Semaine du " + weekrange.obj.from.getDate() + " " + monthStr(weekrange.obj.from).full.toLowerCase() + " " + weekrange.obj.from.getFullYear() + " au " + weekrange.obj.to.getDate() + " "+ monthStr(weekrange.obj.to).full.toLowerCase()+ " " + weekrange.obj.to.getFullYear()
                            }
                        }
                    }

                    if(!weeks[index].days[day]){
                        // this.$set(weeks[index].days, day, {})
                        // this.$set(weeks[index].days[day], 'label', dayOfWeekStr(date).full + ' ' + date.getDate() + ' ' + monthStr(date).full.toLowerCase())
                        // this.$set(weeks[index].days[day], 'data', [])
                        weeks[index].days[day]={
                            dateStr: date.getFullYear()+'-'+(date.getMonth()+1).toString().padStart(2, '0')+'-'+date.getDate().toString().padStart(2, '0'),
                            label: dayOfWeekStr(date).full + ' ' + date.getDate() + ' ' + monthStr(date).full.toLowerCase(),
                            data: []
                        }
                    }

                }.bind(this))

                this.weeks=weeks;
                
                clearTimeout(this.emitLoadedTO);
                this.emitLoadedTO = setTimeout(function(){
                    this.$emit('schedule-loaded');
                }.bind(this), 200)

                if(callback) callback(true);
            }
        },
        apollo: {
			resourceAssignments: {
				query: RESOURCESASSIGNMENTS,
				fetchPolicy: 'cache-and-network',
				debounce: 500,
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
				variables(){
					let variables={
						resourceID: this.resourceID,
						dateRange: this.weekrange.str,
						first: 250,
                        includePast: true
					}
					return {
						...variables
					}
				},
                update(data) {
                    this.parseData(data.resourceAssignments.data)
                }
			},
			resourceUnavailabilities: {
				query: RESOURCEUNAVAILABILITIES,
				fetchPolicy: 'cache-and-network',
				debounce: 500,
				variables(){
					let variables={
						resourceID: this.resourceID,
						dateRange: this.weekrange.str,
					}
					return {
						...variables
					}
				},
				update(data){
                    this.parseData(data.resourceUnavailabilities.data)
                }
			}
        }
    }
</script>
<style lang="scss">
    @import "@/scss/components/dashboard/ScheduleList.scss";
</style>
<style lang="scss" scoped>
        .c-schedule-list-assignment__row .-project{
            width: auto;
            flex-grow: 1;
        }
</style>